module.exports = __webpack_public_path__ + "img/p5.88d602e3.png";